<div class="container-fluid p-3">

  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">{{ format == 'upload' ? 'Upload Compliance of PDS/PRU' : 'Sharing of PDS/PRU'}}</h4>
        <h5 class="text-primary">[{{ proposalName }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <!-- <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button> -->

        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container *ngIf="
            stepDetails?.is_initiator ||
            stepDetails?.is_approver ||
            stepDetails?.is_recommender ||
            (stepDetails?.step_status != 'approved' && userID == 6)
          ">
          <!-- <button
            class="btn btn-primary me-2"
            (click)="onSubmit()"
            [disabled]="RFPForm.invalid"
          >
            <i class="pi pi-save me-1"></i> Submit
          </button> -->
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_initiator">
          <button class="btn btn-success" (click)="IRA.emit('Initiate')">
            <i class="pi pi-play me-1"></i> Initiate
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_approver">
          <button class="btn btn-success" (click)="IRA.emit('Approve')">
            <i class="pi pi-check-circle me-1"></i> Approve
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_recommender">
          <button class="btn btn-info" (click)="IRA.emit('Recommend')">
            <i class="pi pi-thumbs-up me-1"></i> Recommend
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />

  <form class="proposal-form-container">
    <div class="form-container">
      <!-- === Collapsible Section Template Example === -->
      <div class="form-section">
        <div class="section-header" (click)="toggleSection('basicInfo')">
          <h3 class="section-title">
            PDS Document
            <i class="pi" [ngClass]="expandedSections['basicInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </h3>
        </div>
        <div class="section-content" *ngIf="expandedSections['basicInfo']">
          <div class="form-grid">
            <div class="form-field full-width">
                <div *ngIf="docuemntList?.pds_file">
                  <h5 class="mt-4">
                    PDS Document
                  </h5>
                  <ul>
                    <li *ngIf="docuemntList.pds_file">
                      <a [href]="baseUrl + docuemntList.pds_file" target="_blank" rel="noopener noreferrer">
                        {{ getFileName(docuemntList.pds_file) }}
                      </a>
                    </li>
                  </ul>
                </div>
                <div *ngIf="docuemntList?.pru_file">
                  <h5 class="mt-4">
                    PRU Document
                  </h5>
                  <ul>
                    <li *ngIf="docuemntList.pru_file">
                      <a [href]="baseUrl + docuemntList.pru_file" target="_blank" rel="noopener noreferrer">
                        {{ getFileName(docuemntList.pru_file) }}
                      </a>
                    </li>
                  </ul>
                </div>
                <div *ngIf="!docuemntList.pds_file && !docuemntList.pru_file">
                  <p class="text-muted">
                    No Files.
                  </p>
                </div>
            </div>
          </div>
        </div>
      </div>
      <!-- === File Upload Section === -->
      <div class="form-section">
        <div class="section-header" (click)="toggleSection('uploads')">
          <h3 class="section-title">
              Documents Upload
            <i class="pi" [ngClass]="expandedSections['uploads'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </h3>
        </div>
        <div class="section-content" *ngIf="expandedSections['uploads']">
          <!-- Document Upload Table -->
          <app-upload-document (uploadData)="onDocumentUpload($event)" [dmsFiles]="allDmsFiles"
            (documentEdited)="onDocumentEdited($event)" (documentDeleted)="onDocumentDeleted($event)">
          </app-upload-document>
        </div>
      </div>
    </div>
  </form>
  <!-- <div class="form-section card">
    <div *ngIf="docuemntList?.pds_file">
      <h5 class="mt-4">
        PDS Document
      </h5>
      <ul>
        <li *ngIf="docuemntList.pds_file">
          <a [href]="baseUrl + docuemntList.pds_file" target="_blank" rel="noopener noreferrer">
            {{ getFileName(docuemntList.pds_file) }}
          </a>
        </li>
      </ul>
    </div>
    <div *ngIf="docuemntList?.pru_file">
      <h5 class="mt-4">
        PRU Document
      </h5>
      <ul>
        <li *ngIf="docuemntList.pru_file">
          <a [href]="baseUrl + docuemntList.pru_file" target="_blank" rel="noopener noreferrer">
            {{ getFileName(docuemntList.pru_file) }}
          </a>
        </li>
      </ul>
    </div>
    <div *ngIf="!docuemntList.pds_file && !docuemntList.pru_file">
      <p class="text-muted">
        No Files.
      </p>
    </div>
  </div> -->
  <!-- <div class="card shadow-sm border-0 p-4">
    <p-accordion>
      <p-accordionTab *ngFor="let row of winners; let i = index"
        [header]="row.vendor.name + ' - ' + row.vendor.company_name">
        <div class="row mb-4">
          <div class="col-lg-8">
            <div class="card shadow-sm border-0">
              <div class="card-body p-4">
                <div class="d-flex align-items-center mb-3">
                  <i class="pi pi-file text-primary me-2"></i>
                  <h5 class="card-title mb-0">Vendor Document</h5>
                </div>

                <p class="text-muted mb-4">
                  Please upload your document in PDF, DOCX, CSV, JPEG, JPG, or PNG format (Max size: 200MB)
                </p>
                <div class="upload-container mb-4"
                  *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender || (stepDetails?.step_status != 'approved' && userID == 6)">
                  <div class="upload-area p-4 text-center border rounded">
                    <p-fileUpload #fileUpload mode="basic" chooseLabel="Browse Files" [auto]="true"
                      [customUpload]="true" [multiple]="true" name="files[]"
                      [accept]="'.pdf,.docx,.csv,.jpeg,.jpg,.png'" [maxFileSize]="209715200"
                      (onSelect)="onMultipleFileUpload($event, row)">
                    </p-fileUpload>

                    <button class="btn btn-sm btn-primary mt-3"
                        (click)="saveRow(row)">
                  <i class="pi pi-upload me-1"></i> Upload
                </button>
                 
                    <ng-container *ngIf="row.tempDocuments && row.tempDocuments.length > 0">
                      <ul class="list-unstyled">
                        <li *ngFor="let file of row.tempDocuments">
                          {{ file.name }}
                        </li>
                      </ul>

                      <button class="btn btn-sm btn-primary mt-2" (click)="saveRow(row)">
                        <i class="pi pi-upload me-1"></i> Upload
                      </button>
                    </ng-container>

                    <ng-container *ngIf="(!row.documents?.length && !row.tempDocuments?.length)">
                      <span class="text-muted">No documents uploaded</span>
                    </ng-container>
                  </div>
                </div>
                <div *ngIf="!row.documents?.length" class="no-file-placeholder p-3 text-center bg-light rounded">
                  <i class="pi pi-inbox text-muted mb-2" style="font-size: 1.5rem;"></i>
                  <p class="mb-0 text-muted">No files uploaded</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <ng-container *ngIf="row.documents && row.documents.length > 0">
            <h6 class="text-success">Uploaded Files</h6>
            <ul class="list-unstyled">
              <li *ngFor="let doc of row.documents">
                <a [href]="baseUrl + doc.fileId" [attr.download]="doc.fileName" target="_blank">
                  {{ doc.fileName }}
                </a>
              </li>
            </ul>
          </ng-container>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div> -->
</div>